import fonts from './fonts'
import colors from './colors'
import media from './media'
import parking from './parking'

export default {
  fonts,
  colors,
  media,
  borderRadius: '4px',
  boxShadow: {
    basic: '0 9px 24px 0 rgba(35,41,48,0.15)',
    hover: ''
  },
  // Parking-flow redesign tokens. Parking-scoped; does not alter shared
  // defaults. Consume as `props.theme.parking.*`.
  parking
}
